import { SITE_URL, DEFAULT_OG } from "./Seo";

export const businessLd = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#business`,
  name: "Ananda Paudel — Interior Designer & Furniture Specialist",
  alternateName: "Ananda Paudel Interiors",
  description:
    "Bespoke interior design, custom furniture design, and end-to-end build services in Nepal. 40+ years of experience, factory-direct fabrication.",
  url: `${SITE_URL}/`,
  telephone: "+977-9841488271",
  email: "ananda.paudel.work@gmail.com",
  image: DEFAULT_OG,
  logo: DEFAULT_OG,
  priceRange: "$$$",
  founder: { "@type": "Person", name: "Ananda Paudel" },
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kathmandu",
    addressRegion: "Bagmati",
    addressCountry: "NP",
  },
  areaServed: [
    { "@type": "City", name: "Kathmandu" },
    { "@type": "City", name: "Lalitpur" },
    { "@type": "City", name: "Bhaktapur" },
    { "@type": "City", name: "Pokhara" },
    { "@type": "Country", name: "Nepal" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "19:00",
    },
  ],
  slogan: "Consulting. Design. Build.",
});

export const websiteLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: `${SITE_URL}/`,
  name: "Ananda Paudel — Interior Designer & Furniture Specialist",
  inLanguage: "en-NP",
});

export const personLd = () => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": `${SITE_URL}/about#ananda`,
  name: "Ananda Paudel",
  jobTitle: "Interior Designer & Furniture Specialist",
  worksFor: { "@id": `${SITE_URL}/#business` },
  knowsAbout: [
    "Interior Design",
    "Bespoke Furniture",
    "Custom Wardrobes",
    "Sofa Design",
    "Bedroom Furniture",
    "Kids Furniture",
    "Office Furniture",
  ],
  description:
    "Veteran interior designer and furniture specialist with 40+ years of experience in Nepal's furniture industry.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kathmandu",
    addressRegion: "Bagmati",
    addressCountry: "NP",
  },
});

export const serviceLd = ({ name, description, slug, serviceType }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${SITE_URL}/services/${slug}#service`,
  name,
  description,
  serviceType,
  provider: { "@id": `${SITE_URL}/#business` },
  areaServed: [
    { "@type": "City", name: "Kathmandu" },
    { "@type": "City", name: "Lalitpur" },
    { "@type": "City", name: "Bhaktapur" },
    { "@type": "City", name: "Pokhara" },
    { "@type": "Country", name: "Nepal" },
  ],
  url: `${SITE_URL}/services/${slug}`,
});

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const designLd = (design) => ({
  "@context": "https://schema.org",
  "@type": "CreativeWork",
  "@id": `${SITE_URL}/portfolio/${design.slug}#design`,
  name: design.name,
  description: design.description,
  image: design.images?.[0] || design.image,
  creator: { "@id": `${SITE_URL}/about#ananda` },
  provider: { "@id": `${SITE_URL}/#business` },
  url: `${SITE_URL}/portfolio/${design.slug}`,
  keywords: design.tags?.join(", "),
  material: design.material,
});

export const faqLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((q) => ({
    "@type": "Question",
    name: q.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: q.a,
    },
  })),
});

export const contactPageLd = () => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  url: `${SITE_URL}/contact`,
  name: "Contact Ananda Paudel",
  about: { "@id": `${SITE_URL}/#business` },
});
